<script>
import { CSAT_RATINGS } from 'shared/constants/messages';

export default {
  name: 'ReportFiltersRatings',
  emits: ['ratingFilterSelection'],
  data() {
    return {
      selectedOption: null,
      greenSmileyImage: '/brand-assets/green_smiley_emoji.png',
    };
  },
  computed: {
    options() {
      return [...CSAT_RATINGS].reverse().map(option => ({
        key: option.key,
        value: option.value,
        color: option.color,
        emoji: option.emoji,
        label: this.$t(option.translationKey),
        showGreenSmiley: option.key === 'satisfied',
      }));
    },
  },
  methods: {
    handleInput(selectedRating) {
      this.$emit('ratingFilterSelection', selectedRating);
    },
  },
};
</script>

<template>
  <div class="multiselect-wrap--small">
    <multiselect
      v-model="selectedOption"
      class="no-margin"
      :option-height="24"
      :placeholder="$t('FORMS.MULTISELECT.SELECT_ONE')"
      :options="options"
      :show-labels="false"
      track-by="value"
      label="label"
      @update:model-value="handleInput"
    >
      <template #singleLabel="props">
        <div class="flex items-center gap-1">
          <img
            v-if="props.option.showGreenSmiley"
            :src="greenSmileyImage"
            alt="Satisfied"
            class="inline-block w-5 h-5 object-contain"
          />
          <span v-else>{{ props.option.emoji }}</span>
          <span class="my-0 text-slate-800 dark:text-slate-75">
            {{ props.option.label }}
          </span>
        </div>
      </template>
      <template #option="props">
        <div class="flex items-center gap-1">
          <img
            v-if="props.option.showGreenSmiley"
            :src="greenSmileyImage"
            alt="Satisfied"
            class="inline-block w-5 h-5 object-contain"
          />
          <span v-else>{{ props.option.emoji }}</span>
          <span class="my-0 text-slate-800 dark:text-slate-75">
            {{ props.option.label }}
          </span>
        </div>
      </template>
    </multiselect>
  </div>
</template>
